import { createSlice } from "@reduxjs/toolkit";
import { forgotAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const forgotSlice = createSlice({
  name: "forgot",
  initialState: data,
  reducers: {
    forgotSlice(state) {
      state.isLoading = true;
    },
    forgotSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    forgotSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload;
    },
    forgotSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const forgotUserHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(forgotUserAction.forgotSlice());
    const response: any = await forgotAPI(data);
    showSuccessToast(response?.message)
    dispatch(forgotUserAction.forgotSliceSuccess(response));
  } catch (e: any) {
    showErrorToast(e?.response?.data?.message)
    dispatch(forgotUserAction.forgotSliceFailure(e?.response?.data));
  }
};
export default forgotSlice.reducer;
export const forgotUserAction = forgotSlice.actions;
